import Tone from 'tone';

var voiceCount = 0;
class VoiceFactory {
    constructor() {
        this.voices = [];
    }

    newVoice(oscillatorType, name, isCarrier) {
        if (!Tone.Master.context.isOffline && this.voices.length > 0) {
            let voice = this.voices.find(
                v => v.name === name);
            if (voice) {
                let i = this.voices.indexOf(voice);
                this.voices.splice(i, 1);
                if (oscillatorType) {
                    if (oscillatorType.includes("fat")) {
                        voice.oscillator.type = 'sine';
                    }
                    voice.oscillator.type = oscillatorType;
                }
                return voice;
            }
        }
        if (oscillatorType) {
            let v = new Tone.MonoSynth({
                oscillator: {
                    type: oscillatorType
                }
            });
            if (oscillatorType.includes("fat")) {
                v.type = 'sine';
                v.type = oscillatorType;
            }
            v.id = voiceCount;
            return v;
        } else {
            let v = new Tone.MonoSynth();
            v.id = voiceCount;
            return v;
        }
 
    }

    releaseVoice(voice, disconnectFM, sequencerEngine) {
        voice.disconnectFM();
        if (!sequencerEngine.isOffline) {
            this.voices.push(voice);
        }
    }
}

export const voiceFactory = new VoiceFactory();
